/**
 * Detect Vite/webpack dynamic-import failures after a deploy replaces hashed chunks.
 * Without recovery, React leaves the Suspense tree blank (all-black / empty main).
 */
export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { name?: string; message?: string };
  const name = err.name ?? '';
  const message = err.message ?? '';
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

export const CHUNK_RELOAD_SESSION_KEY = 'rendezvous:chunk-reload';

/** Returns true if a reload was triggered (caller should not render fallback). */
export function tryReloadOnceForChunkError(error: unknown, storage: Storage = sessionStorage): boolean {
  if (!isChunkLoadError(error)) return false;
  if (storage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1') return false;
  storage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
  window.location.reload();
  return true;
}

export function clearChunkReloadMarker(storage: Storage = sessionStorage): void {
  storage.removeItem(CHUNK_RELOAD_SESSION_KEY);
}
